import { createStore } from 'vuex';
import persistedstate from 'vuex-persistedstate'

const store = createStore({
    state() {
        return {
            user : {},
            // 실시간 시간
            liveTime: "",
            // 실시간 접속자 수
            liveConnectCount: "",
            // 로그인 상태
            loginState:"0",
        }
    },
    getters: {
       
    },
    mutations : {
        user(state, data) {
            state.user = data;
        }
    },
    plugins : [
        persistedstate({
            paths:['user']
        })
    ],
    actions: {
        
    }
})

export default store;